import {
  GET_LIST_ULTRA_MIKRO,
  LOADING_LIST_ULTRA_MIKRO,
  GET_SUMMARY_ULTRA_MIKRO,
  LOADING_SUMMARY_ULTRA_MIKRO,
  INFINITE_SCROLL_ULTRA_MIKRO,
  LOADING_INFINITE_SCROLL_ULTRA_MIKRO,
  GET_DETAIL_ULTRA_MIKRO,
  LOADING_DETAIL_ULTRA_MIKRO,
} from '../constants/ultra_mikro';

const initialState = {
  listUltraMikroData: { data: [] },
  infiniteListUltraMikroData: { data: [] },
  summaryUltraMikroData: [],
  detailUltraMikroData: {},
  isLoadingListUltraMikroData: true,
  isLoadinginfiniteListUltraMikroData: true,
  isLoadingSummaryUltraMikroData: true,
  isLoadingDetailUltraMikroData: true,
};

export default function reducer(
  state = initialState,
  action = {
    type: '',
    listUltraMikroData: {},
    summaryUltraMikroData: [],
    infiniteListUltraMikroData: { data: [{}] },
    detailUltraMikroData: {},
  }
) {
  const {
    type,
    listUltraMikroData,
    summaryUltraMikroData,
    infiniteListUltraMikroData,
    detailUltraMikroData,
  } = action;

  switch (type) {
    case GET_LIST_ULTRA_MIKRO:
      return {
        ...state,
        listUltraMikroData: listUltraMikroData,
        isLoadingListUltraMikroData: false,
      };
    case INFINITE_SCROLL_ULTRA_MIKRO:
      return {
        ...state,
        listUltraMikroData: {
          ...state.listUltraMikroData,
          data: [
            ...state.listUltraMikroData.data,
            ...infiniteListUltraMikroData.data,
          ],
        },
        isLoadinginfiniteListUltraMikroData: false,
      };
    case LOADING_LIST_ULTRA_MIKRO:
      return {
        ...state,
        isLoadingListUltraMikroData: true,
      };
    case GET_SUMMARY_ULTRA_MIKRO:
      return {
        ...state,
        summaryUltraMikroData,
        isLoadingSummaryUltraMikroData: false,
      };
    case LOADING_SUMMARY_ULTRA_MIKRO:
      return {
        ...state,
        isLoadingSummaryUltraMikroData: true,
      };
    case LOADING_INFINITE_SCROLL_ULTRA_MIKRO:
      return {
        ...state,
        isLoadinginfiniteListUltraMikroData: true,
      };
    case GET_DETAIL_ULTRA_MIKRO:
      return {
        ...state,
        detailUltraMikroData,
        isLoadingDetailUltraMikroData: false,
      };
    case LOADING_DETAIL_ULTRA_MIKRO:
      return { ...state, isLoadingDetailUltraMikroData: true };
    default:
      return state;
  }
}
